<template>
  <div class="check-internation">
    <el-dropdown class="country" trigger="click" @command='checkInternation' placement='bottom-start'>
        <span class="el-dropdown-link" :style="{'color': fontColor}">
            <lang-flag :squared="false" :iso="this.language"/>
            <span>{{ language === 'en' ? 'English' : '中文' }}</span>
            <i class="el-icon-caret-bottom"></i>
        </span>
      <el-dropdown-menu class="dropdown-menu" ref="downdiv" slot="dropdown">
        <el-dropdown-item command="en">
          <lang-flag iso='en' :squared="false"/>
          <span>English</span>
        </el-dropdown-item>
        <el-dropdown-item command="zh">
          <lang-flag iso='zh' :squared="false"/>
          <span>中文</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div ref="newSpace"></div>
  </div>
</template>

<script>
import LangFlag from 'vue-lang-code-flags'
import {applyLatestLanguage} from '@/lang'
import {syncRouteTitles} from '@/utils/settingRouteLang'

export default {
  name: 'Internationalization',
  data() {
    return {
      language: 'en'
    }
  },
  props: {
    fontColor: {
      type: String,
      default: '#606266'
    }
  },
  components: {
    LangFlag
  },
  computed: {
    variables() {
      return variables;
    },
  },
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler(language) {
        this.language = language === 'zh' ? 'zh' : 'en'
      }
    }
  },
  mounted() {
    this.$refs.newSpace.appendChild(this.$refs.downdiv.popperElm)
  },
  methods: {
    checkInternation(res) {
      if (res === this.language) return
      // this.$i18n.locale = res
      localStorage.setItem('language-admin', res)
      // 写入方不会收到 storage 事件，因此当前页签直接应用。
      const result = applyLatestLanguage()
      if (result.changed) syncRouteTitles(result.previousLanguage, result.language)
    }
  }
}
</script>
<!--color: #5a5e66;-->

<style lang="scss" scoped>
.flag-icon {
  height: 26px;
  line-height: 26px;
}

.check-internation {
  display: inline-block;
  cursor: pointer;

  .el-dropdown-link {
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Internationalization/index.vue